// ── Built-in matching activities ─────────────────────────────────────────────
// All content lives in generatedMatchingDecks in Firestore (admin-authored,
// same manual workflow as generatedSequencingDecks). This array intentionally
// stays empty — see SEQUENCING_DECKS for precedent.

export const MATCHING_DECKS = [];

// ── Match types ───────────────────────────────────────────────────────────────
// Controls how a deck is labeled/filtered in the library; every trial has the
// same shape (a prompt card + a choice array) regardless of type.

export const MATCH_TYPES = {
  IDENTICAL: 'identical',
  CATEGORY:  'category',
  WORD:      'word',
  SOUND:     'sound',
};

export const MATCH_TYPE_LABEL = {
  [MATCH_TYPES.IDENTICAL]: 'Identical Match',
  [MATCH_TYPES.CATEGORY]:  'Category Match',
  [MATCH_TYPES.WORD]:      'Picture-to-Word',
  [MATCH_TYPES.SOUND]:     'Sound-to-Picture',
};

// ── Categories ───────────────────────────────────────────────────────────────
export const MATCHING_CATEGORIES = [
  'Hygiene',
  'Daily Living',
  'Social Skills',
  'Community',
  'Safety',
  'Food',
  'Animals',
  'Academic',
  'Emotions',
  'Colors & Shapes',
];

// Suggested categories for MATCH_TYPES.SOUND decks — surfaced as datalist
// hints in the generator, not an enforced enum.
export const SOUND_MATCH_CATEGORIES = [
  'Animal Sounds',
  'Environmental Sounds',
  'Safety Sounds',
  'Letter Sounds',
  'Vehicle Sounds',
  'Instrument Sounds',
];
